/** @file       App.css
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *             Global style for the portal. Should not contain anything specific to a component
 */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.hidden {
  display: none;
}

.split {
  display: flex;
}

.split > div {
  flex: 1 1 auto;
}

.split :nth-child(1) {
  flex-basis: 60%;
}

hr {
  border: none;
  height: 1px;
  background-color: lightgray;
}

a {
  cursor: pointer;
  text-decoration: none;
}

.content a:hover {
  filter: brightness(1.2);
}

.chevron {
  margin-top: 20px;
  position: relative;
  display: block;
  height: 30px; /*height should be double border*/
  width: 30px;
}

.chevron::before,
.chevron::after {
  position: absolute;
  display: block;
  content: "";
  border: 1em solid transparent; /*adjust size*/
}

.chevron::before {
  top: 0;
  border-top-color: var(--primary-hue-main); /*Chevron Color*/
}

.chevron::after {
  top: -4px; /*adjust thickness*/
  border-top-color: #fff; /*Match background colour*/
}

table {
  border-collapse: collapse
}

.loader-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: #fff 
    url("./assets/img/DCP-loading-100.gif") center
    no-repeat;
}

.font-normal {
  font-weight: 400;
}

.font-bold {
  font-weight: 700;
}

.patchNote h3 {
  margin-bottom: 5px;
  font-weight: 400;
  color: black;
  font-size: 1.3m;
}

.patchNote hr {
  height: 4px;
  background-color: #1aa473;
  width: 60%;
  margin-left: 0;
  border-radius: 4px;
}

.patchNote p {
  margin: 12px 0;
  color: #3a3a3a;
}

.patchNote ul {
  font-weight: 400;
  color: #3a3a3a;
  padding-left: 20px;
  list-style: circle;
  list-style: inside;
}

.pagination {
  padding-top: 30px;
  display: flex;
  justify-content: left;
  color: #1aa473;
}

.page-item {
  padding: 6px 12px;
}

.paginateArrow {
  padding-top: 7px;
  stroke: var(--primary-hue-main);
}

.active {
  color: black;
}

.card {
  background-color: var(--content-hue-bg);
  border: 1px solid var(--content-hue-main);
}

form:invalid p {
  margin: 0;
  padding-top: 0.5rem;
  color: var(--error-hue);
  margin-bottom: 0;
}
